<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-paste"></i>
        Server Information
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WEBCastle</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Server</a>
          </li>
      </ul>
    </div>
    <vcl-facebook v-if="loading"></vcl-facebook>
    <b-card v-else>
      <!-- <template slot="header">
        <i class='fa fa-align-justify' v-if="server && server.url"></i>
        <span>Agent information</span>
        <strong class="pull-right">Installed Date : {{server.created_at | datetime}}</strong>
      </template> -->
      <template v-if="quick_setting_status" class="animated fadeIn fadeOut">
        <hr>
        <RuleQuickSetup
          v-if="default_rule && default_rule.rule"
          :rule_selected="sel_domain.rule"
          :domain="sel_domain.domain"
          :quick_setting="quick_setting"
          :ico="ico"
          :is_one="is_one"
          :crs_rule="default_rule.rule"
          :setting_level="setting.level"
          :setting_mode="setting.mode"
          :user="user"
          :is_first="is_first"

          @save_default="save_default"
          @status="() => { quick_setting_status = false; is_first = false }"
          @quick_setting_update="(data) => { quick_setting = Object.assign({}, quick_setting, data) }"
        >
        </RuleQuickSetup>
      </template>
      <b-card v-if="server && !quick_setting_status">
        <b-row>
          <b-col md="8">
            <b-form-checkbox v-model="setting.status" v-on:change="status_save($event, setting.status)" name="check-button" switch>
              WEBCastle Engine (global)
              On / Off
            </b-form-checkbox>
          </b-col>
          <b-col md="4">
            <b-button class="pull-right" size="sm" variant="outline-primary" @click="quick_setting_status = true">Quick Setup Guide </b-button>
          </b-col>
        </b-row>
      </b-card>
      <b-card v-if="server && !quick_setting_status">
        <b-row class="text-center" v-if="server.os_type">
          <b-col sm="2">
            <span style="cursor: pointer;" @click="modal_name = true">Name (<i class="fa fa-question"></i>)</span>
            <br>
            <b-button variant="link" @click="nickname_modify_modal = true">{{server.nickname}}</b-button>
          </b-col>
          <b-col sm="2">
            IP
            <br>
            {{ (server.ip_addr_public && server.ip_addr_public == server.ip_addr_private ? server.ip_addr_public : server.ip_addr) || '-' }}
            <!-- {{server.ip_addr || '-'}} -->
          </b-col>
          <b-col sm="2">
            OS
            <br>
            {{server.os_type  || '-'}}
          </b-col>
          <b-col sm="2">
            WAS
            <br>
            {{server.iwaf_type  || '-'}}
          </b-col>
          <b-col sm="2">
            Version
            <br>
            {{server.version  || '-'}}
          </b-col>
          <b-col sm="2">
            Status
            <br>
            <b-badge variant="success" v-if="info.ms">Online</b-badge>
            <b-badge v-else variant="secondary">Offline</b-badge>
          </b-col>
        </b-row>
        <hr>
        <b-row class="text-center">
          <b-col md="3" style="cursor: pointer;">
            <strong class="mb-2" @click="explain_user_crs = true">Virtual Domain Selection (?) </strong>
            <hr>
            <b-form-select v-model="sel_domain.domain" @change="change_domain($event, sel_domain.id)" size="sm" style="max-width: 20rem;">
              <option v-for="item in server.policy_json.domains" :key="item.id" :value="item.domain">{{item.domain}}</option>
            </b-form-select>
          </b-col>
          <b-col md="3" style="cursor: pointer;">
            <strong style="cursor: pointer;" @click="explain_level = true">Policy Security Level <span>(?)</span></strong>
            <hr>
            <!-- <small style="cursor: pointer;" @click="explain_level = true">( Level : {{setting.level}} )</small> -->
            <b-form-radio-group v-model="setting.level" style="cursor: pointer;" id="ph_level" @change="(x) => { change_level_value.prev = change_level_value.new; change_level_value.temp = change_level_value.prev;  change_level_value.new = x; change_level_value.prev < change_level_value.new ? change_level_modal = true : $refs.RuleSelector.$children.forEach(r => r.parser_setting()) }" :options="codes.WAF_LEVEL"></b-form-radio-group>
          </b-col>
          <b-col md="4" style="text-align: center; cursor: pointer;">
            <strong @click="explain_mode = true">Firewall Mode (?) :
              <b-badge v-if="setting.mode == 0" variant="secondary">Off</b-badge>
              <b-badge v-if="setting.mode == 1" variant="warning">DetectionOnly</b-badge>
              <b-badge v-if="setting.mode == 2" variant="danger">Block</b-badge>
            </strong>
            <hr>
            <b-form-radio-group id="ph_mode"
              @change="(x) => { change_mode_value.prev = change_mode_value.new; change_mode_value.temp = change_mode_value.prev; change_mode_value.new = x; }"
              v-model="setting.mode" :options="codes.WAF_MODE_OPTION_EN">
            </b-form-radio-group>
          </b-col>
          <b-col md="2">
            <div>
              <b-button block size="sm" class="mb-2 btn-add" variant="success" @click="rule_confirm = true">Apply</b-button>
              <b-button block size="sm" class="mb-2" variant="warning" @click="apply_modal = true">Clone to Server</b-button>
              <b-button block size="sm" class="mb-2" variant="primary" @click="explain_user_crs = true">Domain Manage</b-button>
            </div>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="10">
            <b-form-group>
              <h5>
                <b-badge variant="warning">Notice</b-badge>
                <small> <strong> The policy security level defaults to 1 and higher levels may affect the service </strong></small><br>
                <small> <strong> * Off : Disable WEBCastle function for the currently selected domain </strong></small><br>
                <small> <strong> * DetectionOnly : Detect Only while on Activation </strong></small><br>
                <small> <strong> * On : Block While On Activation </strong></small><br>
                <!-- <small> <strong> * Multiplexing : Managed by a multiplexed firewall policy </strong></small> -->
              </h5>
            </b-form-group>
          </b-col>
          <b-col>
            <b-row>
              <b-col>
                <!-- <b-button class="" size="sm" block variant="outline-success" @click="download_policy()">Policy Export</b-button>
                <b-button class="mt-2" size="sm" block variant="outline-info" @click="upload_policy = true">Policy Import</b-button> -->
                <b-button size="sm" v-if="server.is_alive" block @click="modal_del = true" variant="danger">Remove</b-button>
                <b-button class="mt-2" size="sm" block variant="light" @click="list()">List</b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
      <!-- 탭부분 시작 -->
      <b-tabs v-model="tabIndex" v-if="server && !quick_setting_status">
        <!-- 방화벽 기본 정책 설정 -->
        <b-tab style="cursor: pointer;" title="Policy (CRS)">
          <b-row>
            <b-col>
              <strong>You can set firewall policies, only enable or disable</strong>
              <!-- 1. Quick은 사용하는 서비스 선택, (기본 설정들 보여줌) -->
              <!-- 2. allow ip 선택 -->
              <!-- <span ㄴclass="pull-right">Version : <strong >{{ default_rule.version }}</strong></span> -->
              <!-- <b-form-select class="float-right ml-2" v-model="target_crs_rule" @change="() => change_main_policy = true" size="sm" style="max-width: 10rem;">
                <option  v-for="item in crs_version_list" :value="item">{{item.version}}</option>
              </b-form-select>
              <Bell style="float:right; margin-top:5px;" :size="20" :count="crs_rule_count" v-if="get_max_policy()" /> -->
            </b-col>
          </b-row>
          <hr>
          <p block class="bg-danger p-1 pl-3 pr-3 fadeIn fadeOut rounded-pill" v-if="policy_changed && policy_changed.length > 0">
            <strong>* There's a changed policy. If you change the level, the changes may be restored. we recommend saving it, first.</strong>
          </p>
          <RuleService
            v-if="!quick_setting_status"
            :quick_setting="quick_setting"
            :ico="ico"
            @toggle_policy="toggle_policy"

          >  </RuleService>
          <hr v-if="!quick_setting_status" class="animated fadeIn fadeOut">
          <template v-if="!quick_setting_status" class="animated fadeIn fadeOut">
            <RuleSelector
              class="animated fadeIn fadeOut"
              ref="RuleSelector"

              :rule_selected="sel_domain.rule"
              :rule_data="rule_set.rule"
              :rule_block="sel_domain.block"
              :rule_detect="sel_domain.detect"
              :mode="setting.mode"
              :level="setting.level"
              :opened="rule_open"

              @policy_rule="policy_rule"
              @quick_policy_one="(data) => quick_setting = Object.assign({}, quick_setting, data)"
              @block_policy="(block) => sel_domain = Object.assign({}, sel_domain, { block : block })"
              @detect_policy="(detect) => sel_domain = Object.assign({}, sel_domain, { detect : detect })"
              @rule_sel="(x) => sel_domain = Object.assign({}, sel_domain, { rule : x })"
              @rule_open="(x) => filter_rule_open(x)"
              @is_changed="(x) => policy_changed = x"

              v-bind:toss_rule="save"
              v-if="sel_domain"
            />
           </template>
        </b-tab>
        <!-- 방화벽 사용자 설정 -->
        <!-- custom 문법 체크가 필요함 -->
        <b-tab style="cursor: pointer;" title="Custom Policy (Custom-CRS)">
          <b-row>
            <b-col>
              <strong>
                <b-badge variant="warning">Notice</b-badge> : Use only by experts.
                <hr>
                User Custom CRS Setting
              </strong><br><br>
              <span>Allows the user to customize the rule.</span><br>
              <strong>Please specify the rule id 6000000-+ ID.</strong>
              <!-- 커스텀 부분으로 룰 활성화 부분 안내 -->
              <hr>
              <b-form-group>
                <b-form-checkbox v-model="is_redir" ><p class="text-danger text-bold">Provides redirection for detection in blocking mode</p></b-form-checkbox>
                <b-form-input placeholder="Example) http://f1security.co.kr/warning.html" v-model="using_redir" @change="redir_change"></b-form-input>
              </b-form-group>
              <hr>
              Rule 920350 about "Host Header is a numeric IP address"
              <br>
              <br>
              Example : SecRuleUpdateActionById 920350 "t:none,msg:'Network Attack',allow"
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col>
              <b-form-group>
                <b-form-textarea id="ph_content" v-model="user.custom_rule" :rows="line_count()" :max-rows="80"></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-tab>
        <!-- ip 관련 접근 제어 -->
        <b-tab style="cursor: pointer;" title="IP Address">
          <RuleIP
            class="animated fadeIn fadeOut"
            @block_ip="($val, key) => user.block_ip = $val"
            @allow_ip="($val, key) => user.allow_ip = $val"
            :origin="{ allow_ip : user.allow_ip, block_ip: user.block_ip }"
            :is_setup="false"
            :setting="{ mode: server.mode, level : setting.level }"
          ></RuleIP>
        </b-tab>
        <b-tab style="cursor: pointer;" title="Path & Parameter(Query String)">
          <b-row>
            <b-col>
              <!-- @update 에서 key 는 구분자임 -->
              <!-- path 관련 사용자 정책 설정 -->
              <RuleCustom
                class="animated fadeIn fadeOut"
                :origin="user.path"
                name="Management path"
                type="path"
                :is_setup="false"
                example="/admin,/manager"
                @update="($val, key) => user.path = $val"
              ></RuleCustom>
            </b-col>
            <b-col>
              <!-- </b-tab>
              <b-tab style="cursor: pointer;" title="Parameter(Query String)"> -->
                <!-- 파라미터 관련 사용자 설정 -->
                <!-- @update 에서 key 는 구분자임 -->
              <RuleCustom
                class="animated fadeIn fadeOut"
                :origin="user.parameter"
                name="Management params"
                type="params"
                example="id=test : Detects if query string has id=test,test : Detects if query string has test"
                :is_setup="false"
                @update="($val, key) => user.parameter = $val"
              ></RuleCustom>
            </b-col>
          </b-row>
        </b-tab>
        <!-- CUSTOM country code -->
        <b-tab style="cursor: pointer;" title="Country">
          <RuleCountry
            ref="_country"
            class="animated fadeIn fadeOut"
            :origin="user.country_code"
            :origin_use_geoip="user.use_geoip"
            :db_update_available="db_update_available()"
            :mmdb_version="server.mmdb_version"
            :mmdb_latest="webcastle_mmdb"

            name="country_code"
            @update="($val, key) => user.country_code = $val"
            @use_geoip="($val, key) => user.use_geoip = $val"
            @update_db="db_update_cmd"
          />
        </b-tab>
        <!-- <b-tab style="cursor: pointer;" title="Method">
          <RuleMethod
            ref="_method"
            class="animated fadeIn fadeOut"
            :origin="user.method_control"
            :origin_use_method="user.use_method"
            :now_mode="setting.mode"

            name="method"
            @update="($val, key) => user.method_control = $val"
            @use_method="($val, key) => user = Object.assign({}, user, { use_method : $val })"
          />
        </b-tab> -->
        <b-tab style="cursor: pointer;" title="Log" @click="refresh()">
          <b-row>
            <b-col>
              <strong>Displays the detection/blocking logs for the server.</strong><br><br>
              <span>* Only the last 50 real-time displays</span><br>
              <span v-if="th" class="float-right">
                <i class="fa fa-refresh fa-spin"></i>
                Real-time updating
              </span>
              <br><br>
              <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found" class="table-responsive table_add"
                :items="getItems" :fields="fields" :current-page="currentPage" :per-page="50">
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
                <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
                <template slot="created_at" slot-scope="row">{{ row.item.created_at| sdate }}</template>
                <template slot="remote_addr" slot-scope="row">
                  {{row.item.remote_addr}}
                  <span v-if="row.item.country" class="flag-icon" :class="set_flag(row.item.country)"></span>
                </template>
                <template slot="is_block" slot-scope="row">
                  <b-badge v-if="row.item.is_block && row.item.block_cnt > 0" variant="danger">Block</b-badge>
                  <b-badge v-else variant="warning">DetectionOnly</b-badge>
                </template>
                <template slot="message" slot-scope="row">
                  <!--parser 실패시 출력 -->
                  <strong v-if="row.item.is_failed">
                    Parsering error, request to Support for checking
                  </strong>
                  <!--parser 실패시 출력 -->
                  <strong v-else @click="log_view(row.item)">
                    {{row.item.title_i18n ? (row.item.title_i18n['EN'].desc || '-') : ruleI18n[row.item.m_id] ? ruleI18n[row.item.m_id]['EN'] : (row.item.title || '-') }}
                    <!-- {{ruleI18n[row.item.message.details.ruleId] ? ruleI18n[row.item.message.details.ruleId]['EN'] : row.item.message.message }} -->
                  </strong>
                </template>
                <template slot="ruleid" slot-scope="row">
                  {{row.item.message ? row.item.message.details.ruleId : row.item.m_id }}
                </template>
                <!-- code.js 에서 끌고 옴.-->
                <template slot="severity" slot-scope="row">
                  <b-badge :variant="codes.WAF_SEVERITY_TO_COLOR_EASY(row.item.severity, 'variant')">
                    {{codes.WAF_SEVERITY_TO_DESC_EASY(row.item.severity, 'EN')}}
                  </b-badge>
                </template>
                <!-- <template slot="severity" slot-scope="row">
                  <span scope="row" v-if="row.item.message.details.severity == 0"><b-badge variant="danger">Emergency</b-badge></span>
                  <span scope="row" v-else-if="row.item.message.details.severity == 1"><b-badge variant="danger">Alert</b-badge></span>
                  <span scope="row" v-else-if="row.item.message.details.severity == 2"><b-badge variant="danger">Critical</b-badge></span>
                  <span scope="row" v-else-if="row.item.message.details.severity == 3"><b-badge variant="warning">Error</b-badge></span>
                  <span scope="row" v-else-if="row.item.message.details.severity == 4"><b-badge variant="warning">Warning</b-badge></span>
                  <span scope="row" v-else-if="row.item.message.details.severity == 5"><b-badge variant="info">Notice</b-badge></span>
                  <span scope="row" v-else-if="row.item.message.details.severity == 6"><b-badge variant="info">Info</b-badge></span>
                  <span scope="row" v-else><b-badge variant="dark">Not recognized</b-badge></span>
                </template> -->
                <template slot="is_block" slot-scope="row">
                  <b-badge v-if="row.item.is_block" variant="danger">Block</b-badge>
                  <b-badge v-else variant="warning">Detect</b-badge>
                </template>
                <!-- <template slot="uri" slot-scope="row">
                  {{row.item.uri | truncate(50) }}
                </template> -->
              </b-table>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab style="cursor: pointer;" title="Monitoring">
          <b-row v-if="info.ms">
            <b-col class="rounded-lg pt-2 m-2" sm="2">
              <vue-speedometer
                  class="fadeIn fadeOut animated"
                  v-if="info.status && info.status.system_memory_info"
                  style="display:inline-block; height:90px; float:left;"
                  :width="100"
                  :height="100"
                  :needleHeightRatio="0.4"
                  :value="ramStatus"
                  :customSegmentStops='[0, 250, 750, 1000]'
                  :segmentColors='["#22dc6d", "#ffc90e", "#ed1c24"]'
                  :currentValueText="`RAM(${ramStatus} %)`"
                  :customSegmentLabels='[ { text: "L", position: "INSIDE", color: "#fff", }, { text: "N", position: "INSIDE", color: "#fff", }, { text: "H", position: "INSIDE", color: "#fff", }, ]'
                  :ringWidth="18"
                  :needleTransitionDuration="1000"
                  needleTransition="easeElastic"
                  needleColor="#a7ff83"
                  textColor="#000"
                />

                <br>
                <vue-speedometer
                class="fadeIn fadeOut animated"
                v-if="info.status && info.status.system_cpu_info"
                style="display:inline-block; height:90px; float:left;"
                :width="100"
                :height="100"
                :needleHeightRatio="0.4"
                :value="cpuStatus"
                :customSegmentStops='[0, 250, 750, 1000]'
                :segmentColors='["#22dc6d", "#ffc90e", "#ed1c24"]'
                :currentValueText="`CPU(${cpuStatus / 10 } %)`"
                :customSegmentLabels='[ { text: "L", position: "INSIDE", color: "#fff", }, { text: "N", position: "INSIDE", color: "#fff", }, { text: "H", position: "INSIDE", color: "#fff", }, ]'
                :ringWidth="18"
                :needleTransitionDuration="1000"
                needleTransition="easeElastic"
                needleColor="#a7ff83"
                textColor="#000"
              />
            </b-col>
            <b-col class="rounded-lg pt-2 m-2">
              <folderSet  :disk_list="disckStatus"/>
            </b-col>
          </b-row>
          <b-row class="text-center" v-else>
            <b-col>
              The agent is offline
            </b-col>
            <b-col sm="1">
            </b-col>
          </b-row>
          <hr>
          <hr>
          <b-row>
            <b-col sm="12" class="text-center" >
              <p style="display:inline-block; cursor: pointer;" @click="setting.limit_mode = !setting.limit_mode"> <span class="mr-3">Resource Monitoring Alert Setting</span> <i v-if="setting.limit_mode" class="fa fa-refresh fa-spin"></i></p>
              <c-switch class="float-right" color="success" label variant="pill" v-model="setting.limit_mode"/>
              <br>
              <small class="text-danger">
                If the system resource exceeds the threshold, a notification will be generated once for the first time, <br> and a notification can be made when the standard is normal. We recommend 90% threshold and 60% normal standard.
              </small>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col sm="2" class="mt-2">CPU Threshold(90%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" placeholder="90" v-model="setting.limit_cpu"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">RAM Threshold(90%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" placeholder="90" v-model="setting.limit_ram"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">Disk Threshold(90%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" placeholder="90" v-model="setting.limit_disk"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <!-- 여기서 라인 나눔 -->
            <b-col sm="2" class="mt-2">CPU Normal(60%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" v-model="setting.resolve_cpu"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">RAM Normal(60%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" v-model="setting.resolve_ram"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">Disk Normal(60%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" v-model="setting.resolve_disk"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </b-card>
    <!-- for modal -->
    <b-modal title="Status Save?"  class="modal-warning" v-model="status_confirm" @ok="status_save" ok-variant="danger">
      <p>Turn off / turn on the firewall on that server.</p>
    </b-modal>
    <b-modal size="xl" title="Rule Save ?"  class="modal-warning" v-model="rule_confirm" @ok="save" ok-variant="danger" header-bg-variant="danger">
      <b-row>
        <b-col>
          <p>Save changed settings Incorrect rule settings may affect the service</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="1">
        </b-col>
        <b-col v-show="change_level_value.new != '' && change_level_value.prev != change_level_value.new">
          <p>
            <div style="display: inline-block;">
              <p>- Level Changed</p>
              <p>
                Prev : {{ change_level_value.prev }}
              </p>
              <p>
                <strong>
                  Now : {{ change_level_value.new }}
                </strong>
              </p>

            </div>
            <img src="img/waf_level.png" width="200" height="100" style="display: inline-block;">
          </p>
        </b-col>
        <b-col v-show="change_mode_value.new != '' && change_mode_value.prev != change_mode_value.new">
          <p>
            <div style="display: inline-block;">
              <p>- Mode Changed</p>
              <p>
                <b-badge v-if="change_mode_value.prev == 0" variant="secondary">Disable</b-badge>
                <b-badge v-else-if="change_mode_value.prev == 1" variant="warning">Detect</b-badge>
                <b-badge v-else-if="change_mode_value.prev == 2" variant="danger">Block</b-badge>
                =>
                <b-badge v-if="change_mode_value.new == 0" variant="secondary">Disable</b-badge>
                <b-badge v-else-if="change_mode_value.new == 1" variant="warning">Detect</b-badge>
                <b-badge v-else-if="change_mode_value.new == 2" variant="danger">Block</b-badge>
              </p>
            </div>
            <!-- 탐지 모드 사진 -->
            <img v-if="change_mode_value.new == 1" src="img/wc_detect.png" width="300" style="display: inline-block; margin-left: 20px;">
            <!-- 차단 모드 사진 -->
            <img v-if="change_mode_value.new == 2" src="img/wc_block.png" width="300" style="display: inline-block; margin-left: 20px;">
          </p>
        </b-col>
        <b-col sm="1">
        </b-col>
      </b-row>

      <h5 class="float-left" v-if="policy_changed && policy_changed.length > 0">Only Showing CRS Policy</h5>
      <h5 class="float-right" v-if="policy_changed && policy_changed.length > 0">Total Policy Changed : {{ policy_changed.length || 0 }}</h5>

      <b-table v-if="policy_changed && policy_changed.length > 0" ref="_list_changed" striped hover small fixed class="table-responsive-sm" :items="policy_changed" :fields="changed_fields" empty-text="not found">
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template slot="key" slot-scope="row">
          {{ row.item.key }}
        </template>
        <template slot="desc" slot-scope="row">
          {{ruleI18n[row.item.key] ? ruleI18n[row.item.key]['EN'] : row.item.message.message }}
        </template>
        <template slot="level" slot-scope="row">
          {{row.item.level}}
        </template>
        <template slot="severity" slot-scope="row">
          <b-badge v-if="row.item.severity == 'emergency'" variant="danger">{{row.item.severity}}</b-badge>
          <b-badge v-if="row.item.severity == 'critical'" variant="danger">{{row.item.severity}}</b-badge>
          <b-badge v-else-if="row.item.severity == 'error'" variant="warning">{{row.item.severity}}</b-badge>
          <b-badge v-else-if="row.item.severity == 'notice'" variant="warning">{{row.item.severity}}</b-badge>
          <b-badge v-else-if="row.item.severity == 'warning'" variant="warning">{{row.item.severity}}</b-badge>
          <b-badge v-else-if="row.item.severity == 'alert'" variant="dark">{{row.item.severity}}</b-badge>
          <b-badge v-else variant="light">{{'None'}}</b-badge>
        </template>
        <template slot="use" slot-scope="row">
          <b-badge v-if="row.item.origin_use" variant="success">Enable</b-badge>
          <b-badge v-else variant="dark">Disable</b-badge>
          =>
          <b-badge v-if="row.item.use" variant="success">Enable</b-badge>
          <b-badge v-else variant="dark">Disable</b-badge>
        </template>
        <template slot="mode" slot-scope="row">
          <b-badge v-if="row.item.origin_mode" variant="danger">Block</b-badge>
          <b-badge v-else variant="warning">Detect</b-badge>
          =>
          <b-badge v-if="row.item.mode" variant="danger">Block</b-badge>
          <b-badge v-else variant="warning">Detect</b-badge>
          <!-- <b-button size="sm" :disabled="is_add_domain_lock || row.item.temp" variant="outline-warning" @click="domain_manage_regist(row.item.domain, `${row.item.domain}.${(new Date()).getTime()}`)">Clone</b-button>
          <b-button :disabled="is_add_domain_lock" v-if="row.item.domain != 'default'" size="sm" variant="outline-danger" @click="domain_direct_remove(row.item)">Remove!</b-button> -->
        </template>
      </b-table>
    </b-modal>
    <!-- 레벨 설명 모달 -->
    <b-modal title="Explain Level Coverage"  class="modal-info text-center" v-model="explain_level" ok-only no-close-on-backdrop ok-variant="success">
      <div class="text-center">
        <img src="img/waf_level.png"
          class="text-center"
          style="margin-left: auto; margin-right: auto;width: 90%;"
        >
      </div>
      <hr>
      Level 4 is detect by policy level 1 ~ 4<br>
      Level 3 is detect by policy level 1 ~ 3<br>
      Level 2 is detect by policy level 1 ~ 2<br>
      Level 1 is detect by policy level 1<br>
      <hr>
      <p>
        The higher the level, the deeper the attack is detected.
        After setting the level, detailed policy setting is recommended.
      </p>
    </b-modal>

    <!-- 다른 서버 적용 모달 -->
    <b-modal hide-footer title="Agents to apply the policy to" size="xl" v-model="apply_modal" header-bg-variant='warning'>
      <!-- <b-button size="sm" variant="primary" @click="() => { policy_list = server.policy_json.domains.map(r => r.domain) }"> Select All </b-button> -->
      <b-button size="sm" variant="warning" @click="policy_list = []"> Clear </b-button>
      <hr>
      <p class="m-2">
        <b-form-checkbox-group class="m-2"  v-model="policy_list">
          <b-form-checkbox v-for="policy in server.policy_json.domains" :key="policy.id"  :value="policy.domain">
            {{policy.domain}}
          </b-form-checkbox>
        </b-form-checkbox-group>
      </p>
      <hr v-if="apply_all_server && apply_all_server.length > 0">
      <b-badge variant="success" v-for="(item, index) in apply_all_server" :key="index" class="m-1">
        <h6 @click="multi_remove(index)" style="cursor:pointer;">{{item.nickname}} <span class="m-1" style="cursor:pointer;">X</span></h6>
      </b-badge>
      <hr>
      <agent-List :agent_id="server.id" :list_selected="apply_all_server"  :only_select="true" @multi_clear="multi_clear" @multi_all="multi_all" @multi_one="multi_one"></agent-List>
      <hr>
      <b-button block variant="warning" @click="apply_confirm_modal = true" class="m-1">Apply</b-button>
      <b-button block variant="info" @click="apply_modal = false" class="m-1">Close</b-button>
    </b-modal>
    <!-- 다른 서버 적용 모달 다시 확인 -->
    <b-modal hide-footer title="Confirm for apply to policy" size="xm" v-model="apply_confirm_modal" header-bg-variant='danger'>
      Are you sure apply setting to selected agent ?
      <hr>
      <b-button block variant="danger" @click="multi_save" class="m-1">Apply</b-button>
      <b-button block variant="info" @click="apply_confirm_modal = false" class="m-1">Close</b-button>
    </b-modal>
    <!-- 방화벽 운영 모드 관련 안내 모달 -->
    <b-modal title="Domain Manage" class="modal-info" size="xl" v-model="explain_user_crs" no-close-on-backdrop ok-only @ok="explain_user_crs = false">
      <b-table ref="_list" striped hover small fixed class="table-responsive-sm" :items="server && server.policy_json && server.policy_json.domains" :fields="domain_manage_fields" empty-text="not found">
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template slot="domain" slot-scope="row">
          <b-form-input @change="change_policy_name" :disabled="('default' == row.item.domain && row.index == 0) || !row.item.temp" class="pull-right m-1" size="sm" v-model="row.item.domain"></b-form-input>
        </template>
        <template slot="status" slot-scope="row">
          <b-badge v-if="row.item.temp" variant="danger">Un Saved</b-badge>
          <b-badge v-else variant="success">used</b-badge>
          <span v-if="row.item.domain == sel_domain.domain">*</span>
        </template>
        <template slot="mode" slot-scope="row">
          <!-- {{row.item.mode}} -->
          <b-badge v-if="row.item.mode == codes.WAF_MODE_OFF.VALUE || row.item.mode == codes.WAF_MODE_OFF.TEXT" variant="secondary">Off</b-badge>
          <b-badge v-if="row.item.mode == codes.WAF_MODE_DETECTIONONLY.VALUE || row.item.mode == codes.WAF_MODE_DETECTIONONLY.TEXT" variant="warning">DetectionOnly</b-badge>
          <b-badge v-if="row.item.mode == codes.WAF_MODE_ON.VALUE || row.item.mode == codes.WAF_MODE_ON.TEXT" variant="danger">Block</b-badge>
        </template>
        <template slot="level" slot-scope="row">{{row.item.level}}</template>
        <template slot="button" slot-scope="row">
          <b-button size="sm" :disabled="is_add_domain_lock || row.item.temp" variant="outline-warning" @click="domain_manage_regist(row.item.domain, `${row.item.domain}.${(new Date()).getTime()}`)">Clone</b-button>
          <b-button :disabled="is_add_domain_lock" v-if="row.item.domain != 'default'" size="sm" variant="outline-danger" @click="domain_direct_remove(row.item)">Remove!</b-button>
        </template>
      </b-table>
      <hr>
      <p>
        <span v-if="!auth.license.onPremise" class="float-left font-weight-bold text-danger">When charging, subdomains will be charged to one domain.</span>
        <b-button class="btn-addition pull-right m-1" size="sm" variant="success" @click="domain_manage_regist()">Add</b-button>
        <b-form-input class="pull-right m-1" size="sm" v-model="domain" @keyup.native.enter="domain_manage_regist()" placeholder="Domain Add Enter" style="max-width: 20rem;"></b-form-input>
      </p>
    </b-modal>
    <b-modal title="Domain Remove" class="modal-danger" v-model="explain_user_domain" no-close-on-backdrop @ok="domain_manage_remove()" header-bg-variant="danger">
      If you delete an existing domain, your work will be saved as well.
      Existing domain settings will be deleted.
      Do you want to delete it?
    </b-modal>
    <!-- 모드 설명 모달 -->
    <b-modal title="Explain Mode"  class="modal-info text-center" v-model="explain_mode" ok-only no-close-on-backdrop ok-variant="success">
      <b-badge variant="warning">Notice</b-badge>
      <strong> The policy security level defaults to 1 and higher levels may affect the service </strong><br>
      <hr>
      <strong> * Off : Disable Web Castle Activation </strong><br>
      <strong> * DetectionOnly : Detect Only while on Activation </strong><br>
      <strong> * On : Block While On Activation </strong><br>
      <!-- <strong> * Multiplexing : Managed by a multiplexed firewall policy </strong> -->
      <hr>
      <p class="text-center">
        <b-img v-bind="{ width: 300, height: 300, class: 'm1' }" src="img/multi.png" alt="Multiplexing"></b-img>
      </p>
    </b-modal>

    <!-- 모드 설명 모달 -->
    <b-modal title="Change Policy Main Version"  class="modal-warning text-center" v-model="change_main_policy" no-close-on-backdrop ok-variant="success" hide-footer>
      <b-badge variant="warning">Notice</b-badge>
      <strong> Change the firewall's policy </strong>
      <hr>
      <p>Policy Version [ {{crs_rule.version}} ] => <span class="font-weight-bold text-danger">[ {{target_crs_rule.version}} ]</span> </p>
      <hr>
      <p>Required Minimum agent version [ {{crs_rule.agent_version ? crs_rule.agent_version : '-'}} ] => <span class="font-weight-bold text-danger">[ {{target_crs_rule.agent_version ? target_crs_rule.agent_version : '-'}} ]</span> </p>
      <hr>
      <p class="text-danger">* The page will be refreshed by changing the main policy</p>
      <hr>
      <small class="font-weight-bold">* If you have problems after changing a policy, you can restore the policy again.</small>
      <hr>
      <div class="modal-footer">
        <b-button block class="btn btn-success" @click="change_crs">Update</b-button>
        <b-button block class="btn btn-light" @click="change_main_policy = false; target_crs_rule = crs_rule;">Cancel</b-button>
      </div>
    </b-modal>

    <!-- 이름 변경 모달 -->
    <b-modal title="NickName Modify" class="modal-warning text-center" v-model="nickname_modify_modal" no-close-on-backdrop ok-variant="success" hide-footer header-bg-variant="info">
      <p> You can change the nickname of the server. </p>
      <p> Please enter a nickname to change. The first time, the server name is the hostname </p>
      <p> <b> * Check Server Name </b> </p>
      <p> Origin Server Nickname : {{server.nickname}}  </p>
      <b-form-input v-model="modify_nickname" placeholder="Please enter a nickname to change."></b-form-input>

      <div class="modal-footer">
        <b-button block class="btn btn-success" @click="nickname_modify()">Apply</b-button>
        <b-button block class="btn btn-light" @click="nickname_modify_modal = false">Cancel</b-button>
      </div>
    </b-modal>

    <!-- 이름 변경 모달 -->
    <b-modal title="NickName Setting" class="modal-warning text-center" v-model="modal_name" no-close-on-backdrop ok-variant="success" hide-footer header-bg-variant="info">
      <p> You can name it differently from the server host name </p>
    </b-modal>

    <!-- 로그 상세 모달 -->
    <b-modal size="xl" class="modal-warning text-center" v-model="modal_log" no-close-on-backdrop ok-variant="success" hide-footer header-bg-variant="info">
      <LogDetail :id="modal_log_id" @reload="reload()" :only_view="false" />
    </b-modal>

    <!-- 레벨 변경 모달 상세 모달 -->
    <b-modal size="ml" class="modal-warning text-center" v-model="change_level_modal" no-close-on-backdrop ok-variant="success" hide-footer header-bg-variant="warning" @close="back_level_change">
      <h6>Reflect the changed level on whether the policy is used</h6>
      <h6> When changing the policy level, will the previously set policy be reflected?</h6>
      <hr>
      <strong>- YES</strong><br>
      Sets the changed level of policies to Enable.<br>
      Set the policy corresponding to the collectively changed level to Enable.<br>
      <br>
      <strong>- No</strong><br>
      Don't set policies with changed levels to enabled.<br>
      In this case, it is necessary to manually set whether to use it (click the checkbox) when setting it to policy use.<br>
      <br>
      <div class="modal-footer">
        <b-button block class="btn btn-success" @click="() => { toggle_depend_level(); change_level_modal = false; }">Yes</b-button>
        <b-button block class="btn btn-light" @click="change_level_modal = false">No</b-button>
      </div>
    </b-modal>

    <!-- 적용 실패 안내 -->
    <b-modal :title="webcastle_alert_is_error ? 'Error' : 'Successful'" size="ml" :class="`modal-${webcastle_alert_is_error ? 'danger' : 'success'} text-center`" v-model="webcastle_alert" no-close-on-backdrop :ok-variant="webcastle_alert_is_error ? 'danger' : 'success'" ok-only :header-bg-variant="webcastle_alert_is_error ? 'danger' : 'success'">
      <h4 v-if="webcastle_alert_is_error" class="text-danger font-weight-bold">There was a problem applying the changed policy.</h4>
      <h4 v-if="webcastle_alert_is_error" class="text-danger font-weight-bold">I need to save it to the previous settings due to web firewall failure</h4>
      <h4 v-if="webcastle_alert_is_error" class="font-weight-bold">Please check the changes.</h4>
      <h4 v-else class="font-weight-bold"></h4>
      <hr>
      <p>
        msg : {{ webcastle_alert_msg || '-' }}
      </p>
      <br>
    </b-modal>

    <!-- 설정 업로드 모달 -->
    <b-modal title="import or export policy" size="ml" :class="`modal-${webcastle_alert_is_error ? 'danger' : 'success'} text-center`" v-model="upload_policy" no-close-on-backdrop ok-variant="success" ok-only header-bg-variant="success" @ok="upload_policy_save">
        <b-form-file
        v-model="upload_policy_file"
        :state="Boolean(upload_policy_file)"
        placeholder="Choose a file or drop it here..."
        drop-placeholder="Drop file here..."
        @change="upload_policy_change"
      ></b-form-file>

      <b-form-group class="mt-2" label="Choose the domain you want to apply to.">
        <b-form-checkbox
          v-for="(item, index) in upload_policy_data.domains"
          v-model="upload_policy_selected"
          :key="item.domain"
          :value="item.domain"
        >
          {{item.domain}}
        </b-form-checkbox>
      </b-form-group>
      <span class="text-danger">* Matching domain settings are overwritten, policies that do not exist are created.</span>
      <br>
      <span class="text-danger">* Upload may fail if the policy file is not accurate.</span>
      <br>
      <span class="text-danger">* Please check the uploaded policy and save it.</span>
    </b-modal>

    <b-modal title="Delete"  class="modal-danger" v-model="modal_del" @ok="remove" @cancel="del_nickname = '';" header-bg-variant="danger" ok-variant="danger">
      <p> Agent deletion from the server does not automatically delete it Server recommends deleting first  </p>
      <p> If deleted, the firewall will not be processed.  </p>
      <p> <b> * Check Server Name </b> </p>
      <p> Delete Server Nickname : {{server.nickname}}  </p>
      <b-form-input v-model="del_nickname" placeholder="Typing The name of the server you want to unregister"></b-form-input>
    </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
